import { createPortal } from "react-dom";

import { useDebugToggles } from "@/features/visual-debugger";

interface ScrollSpyDebuggerProps {
  rootMargin: string; // e.g., "-25% 0% -70% 0%"
}

export function ScrollSpyDebugger({ rootMargin }: ScrollSpyDebuggerProps) {
  const { scrollSpy } = useDebugToggles();

  if (!scrollSpy) return null;

  const margins = rootMargin.split(" ");

  // IntersectionObserver margins work inversely to CSS Top/Bottom:
  // -25% top margin means the zone starts 25% down from the top.
  // -70% bottom margin means the zone ends 70% up from the bottom.
  const debugStyle: React.CSSProperties = {
    top: margins[0].replace("-", ""),
    bottom: margins[2].replace("-", ""),
  };

  return createPortal(
    <div
      className="fixed left-0 right-0 pointer-events-none z-50 border-t-2 border-b-2 border-dashed border-red-500 bg-red-500/20"
      style={debugStyle}
    >
      <span className="bg-red-500 text-white text-xs px-2 py-1 inline-block align-top">
        TRIGGER ZONE ({rootMargin})
      </span>
    </div>,
    document.body,
  );
}
